export default __webpack_public_path__ + "static/media/Shadowdrinker.fd2d80a3.jpg";